import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X, UserRound } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { scrollToId } from "@/components/SmoothScroll";

const LINKS = [
  { label: "Producto", id: "producto" },
  { label: "Cómo funciona", id: "como-funciona" },
  { label: "Precios", id: "precios" },
  { label: "Soporte", id: "soporte" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, openAuth } = useAuth();
  const [open, setOpen] = useState(false);

  const goTo = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 200);
    } else {
      scrollToId(id);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-[#F3F2F2] border-b-2 border-[#12263A]">
      <nav className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <button onClick={() => navigate("/")} aria-label="Ir al inicio" data-testid="nav-logo-btn">
          <Logo size={38} />
        </button>

        <div className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => goTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-[15px] font-bold text-[#12263A] hover:text-[#2E9EF0] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <button
              onClick={() => navigate("/cuenta")}
              data-testid="nav-account-btn"
              className="flex items-center gap-2 px-4 py-2 rounded-[16px] border-2 border-[#12263A] font-bold text-[#12263A] hover:bg-[#D6D9DC] transition-colors"
            >
              <UserRound size={18} strokeWidth={2} /> Mi cuenta
            </button>
          ) : (
            <button
              onClick={() => openAuth()}
              data-testid="nav-login-btn"
              className="px-4 py-2 rounded-[16px] border-2 border-[#12263A] font-bold text-[#12263A] hover:bg-[#D6D9DC] transition-colors"
            >
              Entrar
            </button>
          )}
          <button
            onClick={() => goTo("precios")}
            data-testid="nav-buy-btn"
            className="px-5 py-2 rounded-[16px] bg-[#2E9EF0] text-[#12263A] border-2 border-[#12263A] font-bold hover:bg-[#12263A] hover:text-[#2E9EF0] transition-colors active:translate-y-0.5"
          >
            Comprar
          </button>
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Menú" data-testid="nav-mobile-toggle">
          {open ? <X size={26} strokeWidth={2} /> : <Menu size={26} strokeWidth={2} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t-2 border-[#12263A] bg-[#F3F2F2] px-5 py-4 flex flex-col gap-3">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => goTo(l.id)} className="text-left font-bold text-[#12263A] py-1">
              {l.label}
            </button>
          ))}
          {user ? (
            <button onClick={() => navigate("/cuenta")} className="text-left font-bold text-[#12263A] py-1">Mi cuenta</button>
          ) : (
            <button onClick={() => openAuth()} className="text-left font-bold text-[#12263A] py-1">Entrar</button>
          )}
          <button
            onClick={() => goTo("precios")}
            className="mt-1 px-5 py-3 rounded-[16px] bg-[#2E9EF0] text-[#12263A] border-2 border-[#12263A] font-bold"
          >
            Comprar
          </button>
        </div>
      )}
    </header>
  );
}
